import Vue from 'vue'
import Router from 'vue-router'
import Index from "../components/Index"
import Login from "../components/Login"
import Register from '../components/Register'
import Home from "../components/User/Home"
import UserIndex from '../components/User/Index'
import UserInfo from '../components/User/Info'
import Qc from '../components/User/Qc'
import Hj from '../components/User/Hj'
import Hj2 from '../components/User/Hj2'
import Record from '../components/User/Record'
import Videohome from '../components/User/Videohome'
import Ku from '../components/User/Ku'
import Developer from '../components/User2/Developer'
import Video_create from '../components/User/Video_create'
import Share from '../components/User/Share'
import Haowu from '../components/User/Haowu'
import Notfound from '../components/Notfound'
import Qsy from '../components/User/Qsy'
import Face from '../views/face.vue'
import Qzm from '../components/User/Qzmwin'
import ShareApp from '../components/ShareApp'
import AppDownload from '../components/AppDownload'
import Vip from '../components/User/Vip'
import Yszc from '../components/service/Yszc'
import Swxy from '../components/service/Swxy'
import user_service from '../components/service/user_service'
import VipService from '../components/service/VipService'
import Qihao from '../components/User/Qihao'
import Haowu_tj from '../components/User/Haowu_tj'
import Vip_open from '../components/User/vip_open'
import Tp_create from '../components/User/Tp/create'
import Tp_list from '../components/User/Tp/list'
import Tp_col from '../components/User/Tp/col'
import Tp_haowu from '../components/User/Tp_haowu'
import Tp_tuiwen from '../components/User/Tp_tuiwen'
import Fan from '../components/User/Fan'
import Workflow from '../components/User/Workflow'
import WorkflowFiles from '../components/User/workflow_files'
import Qcai from '../components/User/Qcai'
import TutorialList from '../components/User/TutorialList'
import TutorialEdit from '../components/User/TutorialEdit'
// import Hjold from '../components/User/Hjold'
//tu
import tu from '../components/tu/index'

// User2 新版页面
import User2Home from '../components/User2/Home'
import User2Index from '../components/User2/Index'
import User2Qc from '../components/User2/Qc'
import User2Qcai from '../components/User2/Qcai'
import User2Ku from '../components/User2/Ku'
import User2Hj from '../components/User2/Hj'
import User2Hj2 from '../components/User2/Hj2'
import User2Qsy from '../components/User2/Qsy'
import User2Qzm from '../components/User2/Qzm'
import User2Watermark from '../components/User2/Watermark'
import User2Custom from '../components/User2/Custom'
import User2Haowu from '../components/User2/Haowu'
import User2Record from '../components/User2/Record'
import User2Share from '../components/User2/Share'
import User2Info from '../components/User2/Info'
import User2Vip from '../components/User2/Vip'
import User2Password from '../components/User2/Password'
import User2ApiKey from '../components/User2/ApiKey'
import User2BuyCdk from '../components/User2/BuyCdk'
import User2ApiDocs from '../components/User2/ApiDocs'
import User2TutorialList from '../components/User2/TutorialList'
import User2TutorialEdit from '../components/User2/TutorialEdit'
import PublicCdk from '../components/PublicCdk'
import { setSiteVersion } from '@/config/siteVersion'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/api-docs',
      name: 'api-docs',
      component: User2ApiDocs
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,

    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/password',
      name: 'User2Password',
      component: User2Password
    },
    {
      path: '/public-cdks',
      name: 'PublicCdk',
      component: PublicCdk
    },
    {
      path: '/buy-cdk',
      name: 'BuyCdk',
      component: User2BuyCdk
    },
    {
      path: '/shareapp',
      name: 'shareapp',
      component: ShareApp
    },
    {
      path: '/duohe-app',
      name: 'duohe-app',
      component: AppDownload
    },
    // {
    //   path: '/user/vip_open',
    //   component: Vip_open,
    // },
    {
      path: '/user/buyvip',
      component: Vip,
    },
    {
      path: '/tu',
      component: tu,
    },
    {
      path: '/yszc',
      name: 'Yszc',
      component: Yszc
    },
    {
      path: '/swxy',
      name: 'Swxy',
      component: Swxy
    },
    {
      path: '/user_service',
      name: 'user_service',
      component: user_service
    },
    {
      path: '/vipservice',
      name: 'VipService',
      component: VipService
    },
    {
      meta: { requiresAuth: true },
      path: '/user/tp/tuiwen',
      component: Tp_tuiwen,
    },
    {
      path: '/home',
      component: Home,
      redirect: '/user/index',//重定向
      meta: { requiresAuth: true },
      children: [
        {
          path: '/user/index',
          component: UserIndex
        },
        {
          path: '/user/info',
          component: UserInfo
        },
        {
          path: '/user/qc',
          component: Qc,
        },
        {
          path: '/user/qcai',
          component: Qcai,
        },
        {
          path: '/user/hj',
          component: Hj,
        },
        {
          path: '/user/hj2',
          component: Hj2,
        },
        // {
        //   path: '/user/hjold',
        //   component: Hjold,
        // },
        {
          path: '/user/video_create',
          component: Video_create,
        },
        {
          path: '/user/videohome',
          component: Videohome,
        }
        ,
        {
          path: '/user/ku',
          component: Ku,
        }
        ,
        {
          path: '/user/workflow',
          component: Workflow,
        }
        ,
        {
          path: '/user/workflow_files',
          component: WorkflowFiles,
        }
        ,
        {
          path: '/user/record',
          component: Record,
        }
        ,
        {
          path: '/user/share',
          component: Share,
        },
        {
          path: '/user/haowu',
          component: Haowu,
        },
        {
          path: '/user/qsy',
          component: Qsy,
        },
        {
          path: '/user/qzm',
          component: Qzm,
        },
        {
          path: '/user/vip',
          component: Vip,
        },
        {
          path: '/user/qihao',
          component: Qihao,
        },
        {
          path: '/user/haowu_tj',
          component: Haowu_tj,
        },
        {
          path: '/user/tp_haowu',
          component: Tp_haowu,
        },
        {
          path: '/user/tp/col',
          component: Tp_col,
        },
        {
          path: '/user/tp/create',
          component: Tp_create,
        },
        {
          path: '/user/tp/list',
          component: Tp_list,
        },
        {
          path: '/user/fan',
          component: Fan,
        },
        {
          path: '/user/face',
          component: Face,
        },
        {
          path: '/user/upload_tutorial',
          component: TutorialList,
        },
        {
          path: '/user/tutorial_edit',
          component: TutorialEdit,
        },
      ]
    },
    // ===== 2.0版本独立路由 =====
    {
      path: '/home2',
      component: User2Home,
      redirect: '/user2/index',
      meta: { requiresAuth: true },
      children: [
        {
          path: '/user2/index',
          component: User2Index
        },
        {
          path: '/user2/qc',
          component: User2Qc
        },
        {
          path: '/user2/qcai',
          component: User2Qcai
        },
        {
          path: '/user2/hj',
          component: User2Hj
        },
        {
          path: '/user2/hj2',
          component: User2Hj2
        },
        {
          path: '/user2/ku',
          component: User2Ku
        },
        {
          path: '/user2/qsy',
          component: User2Qsy
        },
        {
          path: '/user2/qzm',
          component: User2Qzm
        },
        {
          path: '/user2/watermark',
          component: User2Watermark
        },
        {
          path: '/user2/haowu',
          component: User2Haowu
        },
        {
          path: '/user2/custom',
          component: User2Custom
        },
        {
          path: '/user2/record',
          component: User2Record
        },
        {
          path: '/user2/upload_tutorial',
          component: User2TutorialList
        },
        {
          path: '/user2/tutorial_edit',
          component: User2TutorialEdit
        },
        {
          path: '/user2/info',
          component: User2Info
        },
        {
          path: '/user2/vip',
          component: User2Vip
        },
        {
          path: '/user2/share',
          component: User2Share
        },
        {
          path: '/user2/developer',
          component: Developer
        },
        {
          path: '/user2/api-key',
          component: User2ApiKey
        },
      ]
    },
    {
      path: '*',
      name: 'notfound',
      component: Notfound
    }
  ]
})


router.beforeEach((to, from, next) => {
  // 记录用户当前使用的版本：2.0 页面记为 2，1.0 用户页记为 1
  if (to.path.startsWith('/user2') || to.path.startsWith('/home2')) {
    setSiteVersion('2')
  } else if (to.path.startsWith('/user/')) {
    setSiteVersion('1')
  }

  // if(  to.path==='/register' || to.path==='/login' || to.path==='/' || to.path==='/shareapp'){
  //   next()
  //   return
  // }

  // var token=window.localStorage.getItem('token')
  // // console.log(token)
  // if(!token||token==''||token==null||token==undefined){
  //   next('/login')
  // }
  // next()

  if (to.matched.some(route => route.meta && route.meta.requiresAuth)) {
    if (!window.localStorage.getItem('token')) {  // 没有登录信息跳转到登录页
      next({
        path: "/login",
        query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
      });
    } else {
      if (window.localStorage.getItem('end_time')) {
        var timestampInSeconds = Math.floor(new Date().getTime() / 1000);
        if (timestampInSeconds > Number(window.localStorage.getItem('end_time'))) {
          window.localStorage.removeItem('token')
          next({
            path: "/login",
            query: { redirect: to.fullPath }  // 'to.fullPath'跳转到登录之前页面的路径
          });
        }
      }
      next();
    }
  } else {
    next();
  }

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js